import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
import { from } from 'rxjs';
@Component({
    selector: 'app-notification-v2',
    templateUrl: './notification-v2.component.html',
    styleUrls: ['./notification-v2.component.css'],
    standalone: false
})
export class NotificationV2Component implements OnInit {
  url: string;
  MsgType: number;
  DisplayMessage: string;
  Data : any;
  FormSearchNoticeCase: FormGroup;
  modalURL : string;
  Modules: any;
  CallFunctionOnCloseModal: any;
  CurrentModuleID : any;
  ModuleSelected: any;
  ModalHeading: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.CallFunctionOnCloseModal = "RefreshPage";
    this.FormSearchNoticeCase = this.formBuilder.group({
      Modules: ['']
    });

    this.LoadModules();
  }

  LoadNotification(ModuleID)
  {
    this.CurrentModuleID = ModuleID;
    this.http.get(this.url + 'AlertNotificationDetail/LoadNotificationNav?ModuleID=' + ModuleID)
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          this.Data = null;
        } else {
          this.MsgType = 0; // No Message
          this.Data = JSON.parse(data.toString());
        }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }

  LoadModules()
  {
    this.http.get(this.url + 'AlertNotificationDetail/Fetch_Notification_Header_Module?MainID=' + '')
      .subscribe( (data) => {
        this.Modules = JSON.parse(data.toString());
        if(this.Modules.length > 0)
        {
          this.onModuleSelect(this.Modules[0].MainID);
          this.ModuleSelected = this.Modules[0].MainID;
        }
      }
    );
  }

  onModuleSelect(ModuleID) {
    this.LoadNotification(ModuleID);
  }

  OpenModal(url, ID, UserDataID,ModuleID) {
    this.ModalHeading = "Notification Entry";
     this.modalURL =  url + "/"+ UserDataID +"/" + ID+"/"+ModuleID;
   }

   OpenModalFeature(url) {
    this.ModalHeading = "Feature Entry";
    this.modalURL =  url;
  }

   RefreshPage() {
    this.LoadNotification(this.CurrentModuleID);
    this.modalURL = '';
  }
  
  RemoveEmployee(ID){
    this.alertService.showConfirm('Are you sure to remove this user from the list?').then((result) => {
      if (result) {
        this.http.get(this.url + 'AlertNotificationDetail/DeleteNotification?ID=' + ID)
          .subscribe( (data) => {
            this.alertService.success(data.toString() , this.options);
            this.RefreshPage();
          } );
      }
    });
    // if(confirm('Are you sure to remove this user from the list?'))
    // {
    //   this.http.get(this.url + 'AlertNotificationDetail/DeleteNotification?ID=' + ID)
    //     .subscribe( (data) => {
    //       this.alertService.success(data.toString() , this.options);
    //       this.RefreshPage();
    //     }
    //   );
    // }
  }

  
  openMailTemplate(flowId: number): void {
    this.router.navigate(['/editor', flowId],{
      queryParams: { from: 'notification' }
    });
  }
}
